// react
import React, { useState } from 'react';

// third-party
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';

// application
import PageHeader from '../shared/PageHeader';
import theme from '../../data/theme';

export default function AccountPageCreate() {
  const [email, setEmail] = useState('');
  const [load, setLoad] = useState(false);

  const breadcrumb = [
    { title: 'Home', url: '/' },
    { title: 'Akun', url: '/account' },
    { title: 'Daftar', url: '' },
  ];

  const sendEmail = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      toast.error('Alamat email wajib diisi!');
      return;
    }
    try {
      setLoad(true);
      const body = {
        email: email.trim(),
        command: 'REGISTRATION',
      };
      await axios.post(
        `${process.env.REACT_APP_HOST_API}/auth/send-email`,
        body
      );
      setLoad(false);
      toast.success('Link pendaftaran berhasil dikirim ke email Anda. Silakan periksa kotak masuk atau spam!');
    } catch (error) {
      console.log(error);
      setLoad(false);
      const errorMsg =
        error.code === 'ERR_NETWORK'
          ? 'Koneksi jaringan terputus'
          : error.response
            ? error.response.data.message || error.response.data.error
            : 'Gagal mengirim email pendaftaran';
      toast.error(errorMsg);
    }
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>{`Daftar Akun | ${theme.name}`}</title>
      </Helmet>

      <div className="hokky-auth-page-block">
        <PageHeader breadcrumb={breadcrumb} />
        <div className="container hokky-auth-main-container">
          <div className="hokky-auth-container">
            <div className="hokky-auth-card">
              <div className="hokky-auth-header">
                <img
                  src={`${process.env.PUBLIC_URL || ''}/images/logo-footer.png`}
                  alt="Hokky Bangunan"
                  className="auth-brand-logo"
                />
                <h2 className="auth-title">Daftar Akun Baru</h2>
              </div>

              <form className="hokky-auth-form" onSubmit={sendEmail}>
                <div className="auth-form-group">
                  <label htmlFor="register-email">Alamat Email</label>
                  <div className="auth-input-wrapper">
                    <i className="far fa-envelope input-icon-left" />
                    <input
                      id="register-email"
                      type="email"
                      className="auth-input"
                      placeholder="Masukkan email Anda"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      autoComplete="email"
                      required
                    />
                  </div>
                </div>

                <button
                  type="submit"
                  disabled={load}
                  className="btn-auth-submit mt-4"
                >
                  {load ? (
                    <i className="fas fa-spinner fa-spin" />
                  ) : (
                    'Daftar Sekarang'
                  )}
                </button>

                <div className="auth-divider">
                  <span>atau</span>
                </div>

                <p className="auth-footer-prompt">
                  Sudah memiliki akun?
                  <Link to="/account/login" className="auth-link-bold">
                    Masuk di Sini
                  </Link>
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
